module.exports = __webpack_public_path__ + "statics/img/ywl_ios.58b0f521.png";